import React, { forwardRef } from 'react';
import { Minus, TrendingDown, TrendingUp } from 'lucide-react';
import Skeleton from '../Skeleton/Skeleton';
import { cx } from '../utils';
import './StatCard.css';

const TREND_ICON = { up: TrendingUp, down: TrendingDown, neutral: Minus };

function getTrendDirection(trend) {
  const number = typeof trend === 'number' ? trend : parseFloat(String(trend).replace(',', '.'));
  if (Number.isNaN(number) || number === 0) return 'neutral';
  return number > 0 ? 'up' : 'down';
}

function formatTrend(trend) {
  if (typeof trend !== 'number') return trend;
  return `${trend > 0 ? '+' : ''}${trend}%`;
}

// trend: raqam (20.7 → "+20.7%") yoki tayyor matn ("+20.7%"); berilmasa ko'rsatilmaydi.
// tone: ikonka foni — brand | info | success | warning | neutral
const StatCard = forwardRef(function StatCard(
  { icon, label, value, trend, tone = 'brand', loading = false, className, ...rest },
  ref
) {
  const hasTrend = trend !== undefined && trend !== null && trend !== '';
  const direction = hasTrend ? getTrendDirection(trend) : 'neutral';
  const TrendIcon = TREND_ICON[direction];

  return (
    <div {...rest} ref={ref} aria-busy={loading || undefined} className={cx('ui-stat', className)}>
      <div className="ui-stat__top">
        {icon && (
          <span className={cx('ui-stat__icon', `ui-stat__icon--${tone}`)} aria-hidden="true">
            {icon}
          </span>
        )}
        {hasTrend &&
          (loading ? (
            <Skeleton width={56} height={22} radius="full" />
          ) : (
            <span className={cx('ui-stat__trend', `ui-stat__trend--${direction}`)}>
              <TrendIcon aria-hidden="true" />
              {formatTrend(trend)}
            </span>
          ))}
      </div>
      <div className="ui-stat__label">{label}</div>
      <div className="ui-stat__value">
        {loading ? <Skeleton width="45%" height={30} radius="sm" /> : value}
      </div>
    </div>
  );
});

export default StatCard;
